export const SCHOOL_NAME = "schoolName";
export const CONTACT_NO = "phoneNumber";
export const STATE = "state";
export const CITY = "city";
export const ONBOARDING_DATE = "createdAt";
export const DEAL_CLOSED_BY = "dealClosedBy";
